export default __webpack_public_path__ + "static/media/InfinitiCard.136a3c56.png";